import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "全集剧集", to: "/category" },
  { label: "剧情介绍", to: "/plot" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 mb-5">
              {siteInfo.tagline}。专注剧集分集播放入口与剧情深度介绍，让你在一个地方看懂整部剧。
            </p>
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-background-50/10 text-background-100">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-background-50/10 text-background-100">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-background-50/10 text-background-100">
                <i className="ri-mail-send-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <span className="flex items-center justify-center w-5 h-5 shrink-0">
                  <i className="ri-mail-line text-accent-400"></i>
                </span>
                {siteInfo.contactEmail}
              </li>
              <li className="flex items-start gap-2">
                <span className="flex items-center justify-center w-5 h-5 shrink-0">
                  <i className="ri-phone-line text-accent-400"></i>
                </span>
                {siteInfo.contactPhone}
              </li>
              <li className="flex items-start gap-2">
                <span className="flex items-center justify-center w-5 h-5 shrink-0">
                  <i className="ri-map-pin-line text-accent-400"></i>
                </span>
                {siteInfo.address}
              </li>
              <li className="flex items-start gap-2">
                <span className="flex items-center justify-center w-5 h-5 shrink-0">
                  <i className="ri-time-line text-accent-400"></i>
                </span>
                {siteInfo.workTime}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/80">
          <p>{siteInfo.copyright}</p>
          <p>{siteInfo.icp}</p>
        </div>
      </div>
    </footer>
  );
}